export interface EllfWatermarkOptions {
  text?: string;
  alpha?: number;
  lineHeight?: number;
  width?: number;
  height?: number;
  fontSize?: string | number;
  degree?: number;
  color?: string;
}

export const defaultWatermarkOptions: EllfWatermarkOptions = {
  alpha: 0.2,
  lineHeight: 12,
  width: 50,
  height: 30,
  fontSize: '14px',
  degree: -30,
};
